import { render, staticRenderFns } from "./AccountDelegatePage.vue?vue&type=template&id=446f57dc&scoped=true"
import script from "./AccountDelegatePage.vue?vue&type=script&lang=js"
export * from "./AccountDelegatePage.vue?vue&type=script&lang=js"
import style0 from "./AccountDelegatePage.vue?vue&type=style&index=0&id=446f57dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446f57dc",
  null
  
)

export default component.exports